import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "./App.css";
import "./CheckIn.css";
import { AuthProvider, useAuth } from "./context/authContext";
import { DialogProvider } from "./context/dialogContext";
import PrivateRoute from "./components/PrivateRoute";

import Login from "./Login";
import Alumno from "./pages/Alumno";
import Admisiones from "./pages/Admisiones";
import Ensombrado from "./pages/Ensombrado";
import CheckinPage from "./pages/CheckinPage";
import Admin from "./pages/Admin";
import { INICIO } from "./utils";

function Inicio() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={INICIO[user.tipo] || "/login"} replace />;
}

function App() {
  return (
    <AuthProvider>
      <DialogProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Inicio />} />
            <Route path="/alumno" element={<PrivateRoute allowedRoles={["alumno"]}><Alumno /></PrivateRoute>} />
            <Route path="/admisiones" element={<PrivateRoute allowedRoles={["admisiones"]}><Admisiones /></PrivateRoute>} />
            <Route path="/ensombrado" element={<PrivateRoute allowedRoles={["ensombrado"]}><Ensombrado /></PrivateRoute>} />
            <Route path="/checkin" element={<PrivateRoute allowedRoles={["checkin"]}><CheckinPage /></PrivateRoute>} />
            <Route path="/admin" element={<PrivateRoute allowedRoles={["admin"]}><Admin /></PrivateRoute>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </DialogProvider>
    </AuthProvider>
  );
}

export default App;
